import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import { Box } from '@mui/system';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';
import { AUTO_CLOSE_MS, useResultStore } from '../../store/resultStore';

export const ResultAlert = () => {
	const { isOpen, type, text, clear, timeout, messageId } = useResultStore(
		useShallow((state) => ({
			isOpen: state.isOpen,
			type: state.type,
			text: state.text,
			clear: state.clear,
			timeout: state.timeout,
			messageId: state.messageId,
		}))
	);
	const { pathname } = useLocation();
	const previousPathname = useRef(pathname);

	useEffect(() => {
		let timer = null;
		if (isOpen && timeout) {
			timer = setTimeout(() => clear(), timeout);
		}

		return () => timer && clearTimeout(timer);
	}, [isOpen, clear, timeout, messageId]);

	// Some flows show a message and then navigate, so leaving a page must not hide it outright;
	// a pinned error just falls back to auto-closing once the user has moved on.
	useEffect(() => {
		if (previousPathname.current === pathname) return;
		previousPathname.current = pathname;
		const state = useResultStore.getState();
		if (state.isOpen && !state.timeout) useResultStore.setState({ timeout: AUTO_CLOSE_MS });
	}, [pathname]);

	return (
		<Box
			sx={{
				position: 'fixed',
				left: '50%',
				transform: 'translateX(-50%)',
				minWidth: 300,
				maxWidth: 'min(720px, calc(100vw - 32px))',
				zIndex: 1400,
			}}
		>
			{type ? (
				<Collapse in={isOpen}>
					<Alert
						severity={type}
						variant="filled"
						action={
							<IconButton color="inherit" size="small" onClick={() => clear()}>
								<CloseIcon fontSize="inherit" />
							</IconButton>
						}
						sx={{ mb: 2, boxShadow: 3, whiteSpace: 'pre-line', wordBreak: 'break-word' }}
					>
						{text}
					</Alert>
				</Collapse>
			) : (
				<></>
			)}
		</Box>
	);
};

ResultAlert.propTypes = {};
